import { useEffect, useState } from 'react';
import { Navbar, ContactForm, AwardsSection, Footer, LanguageToggle } from '../../components';
import { useScroll } from 'framer-motion';
import { motion } from 'framer-motion'
import { FADE_BOTTOM } from '../../animations';
import { CheckIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import WhatsAppContact from '@/components/WhatsAppContact';

const gabrielaImage = '/images/gabriela_circled.jpeg';
const vascoImage = '/images/team/vasco.png';
const thiagoImage = '/images/team/thiago_costa.png';

interface ContactUsProps {
}

export async function getStaticProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
      ])),
    },
  }
}

export default function Contact({ }: ContactUsProps) {
  const [navbarTransparent, setNavbarTransparent] = useState(true)
  const { scrollYProgress, scrollY } = useScroll()
  const { t, i18n } = useTranslation();

  const router = useRouter();
  const { asPath: pathname, locale } = router;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    scrollYProgress.on('change', (e) => {
      if (scrollY.get() >= 100) {
        setNavbarTransparent(false)
      } else {
        setNavbarTransparent(true)
      }
    })

  }, [])

  return (
    <div className="bg-background-900 min-h-screen w-full overflow-hidden" >
      <Navbar transparent={navbarTransparent} language="en" />
      <div className="isolate  h-[calc(100vh)] flex  relative w-full">
        <div className="absolute opacity-20 inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]">
          <svg
            className="relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]"
            viewBox="0 0 1155 678"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="url(#45de2b6b-92d5-4d68-a6a0-9b9b2abad533)"
              fillOpacity=".3"
              d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
            />
            <defs>
              <linearGradient
                id="45de2b6b-92d5-4d68-a6a0-9b9b2abad533"
                x1="1155.49"
                x2="-78.208"
                y1=".177"
                y2="474.645"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#42a5f5" />
                <stop offset={1} stopColor="#3849ab" />
              </linearGradient>
            </defs>
          </svg>
        </div>


        {/* Form Content */}
        <main className="w-full flex flex-col justify-center mt-16 sm:mt-24 md:mt-28 mx-auto max-w-7xl" >
          <div className="relative px-6 lg:px-8 max-w-7xl ">
            <div className="mx-auto pt-10 pb-14 sm:pt-20 sm:pb-12 ">

              <div className="text-center p-4" >
                <h1 className="text-xl  sm:text-2xl  md:text-3xl lg:text-4xl font-bold tracking-tight text-foreground-primary">
                  {t("contact_us")}
                </h1>

                <motion.h3
                  initial={FADE_BOTTOM.initial}
                  whileInView={FADE_BOTTOM.final}
                  transition={{
                    duration: 0.3,
                    delay: 0.3
                  }}
                  viewport={{ once: true }}
                  className="mt-2 text-lg sm:text-xl md:text-2xl lg:text-2xl font-bold  text-foreground-secondary ">{t("We’d love to work with you!")}
                </motion.h3>
                <div className="w-full flex mt-6 items-center justify-center" >

                </div>

              </div>

              {/* Pattern */}
              <div className="absolute opacity-40 inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <svg
                  className="relative left-[calc(50%+3rem)] h-[21.1875rem] max-w-none -translate-x-1/2 sm:left-[calc(50%+36rem)] sm:h-[42.375rem]"
                  viewBox="0 0 1155 678"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="url(#ecb5b0c9-546c-4772-8c71-4d3f06d544bc)"
                    fillOpacity=".3"
                    d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
                  />
                  <defs>
                    <linearGradient
                      id="ecb5b0c9-546c-4772-8c71-4d3f06d544bc"
                      x1="1155.49"
                      x2="-78.208"
                      y1=".177"
                      y2="474.645"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#3849ab" />
                      <stop offset={1} stopColor="#42a5f5" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

            </div>
          </div>

          <div className=" w-full mx-auto max-w-7xl relative z-20 flex gap-10" >
            <ContactForm />

            <div>
              {locale === 'br' ? (
                <WhatsAppContact avatar={thiagoImage} contactName='Thiago Costa' contactNumber='+556181243822' role='Business Manager' />
              ) : (
                <WhatsAppContact avatar={gabrielaImage} contactName='Gabriela Martins' contactNumber='+351919990051' role='Business Manager' />
              )}
              <div className="h-4" ></div>
              <WhatsAppContact avatar={vascoImage} contactName='Vasco Lopes' contactNumber='+351926472722' role='CEO' />

              <div className="mt-10 h-96 lg:h-80 bg-container-background rounded-[10px] p-10 hidden md:block " >
                <div>
                  <motion.h3
                    initial={FADE_BOTTOM.initial}
                    whileInView={FADE_BOTTOM.final}
                    transition={{
                      duration: 0.3,
                      delay: 0.3
                    }}
                    viewport={{ once: true }}
                    className="mt-2 text-lg lg:text-xl xl:text-2xl font-bold tracking-tight text-gray-100 ">{t("contact_advantage_title")}
                  </motion.h3>

                  <motion.ul
                    initial={FADE_BOTTOM.initial}
                    whileInView={FADE_BOTTOM.final}
                    transition={{
                      duration: 0.3,
                      delay: 0.3
                    }}
                    viewport={{ once: true }}
                    className="mt-3 text-base lg:text-lg xl:text-xl  dark:text-gray-400 text-gray-200 ">
                    <li className="flex items-center mt-2" >
                      <CheckIcon className="w-6 h-6 text-green-500 mr-1" />
                      {t("contact_advantage1")}
                    </li>
                    <li className="flex items-center  mt-2" >
                      <CheckIcon className="w-6 h-6 text-green-500 mr-1" />
                      {t("contact_advantage2")}
                    </li>
                    <li className="flex items-center mt-2" >
                      <CheckIcon className="w-6 h-6 text-green-500 mr-1" />
                      {t("contact_advantage3")}
                    </li>
                    <li className="flex items-center mt-2" >
                      <CheckIcon className="w-6 h-6 text-green-500 mr-1" />
                      {t("contact_advantage4")}
                    </li>
                  </motion.ul>


                </div>


              </div>
            </div>



          </div>
        </main>


      </div>
      {/* <AwardsSection /> */}
      <div className="flex h-24 w-full items-center justify-center  mt-28">

      </div>
      <Footer />
      <LanguageToggle />
    </div>
  );
}
